import React, {useEffect, useState} from "react"
import {LoadingButton} from "@mui/lab"
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material"

const LANGUAGE_RE = /^[a-z]{2}(-[a-z]{2,4})?$/

/**
 * Edit a template text; with askLanguage it also asks for the ISO 639-1 language code (new translation).
 * onSave({text, language}) must return a promise; the dialog stays open while it is pending.
 */
export default function TextEditDialog({open, title, hint, initialText = "", initialLanguage = "", askLanguage = false, loading, onClose, onSave}) {
    const [text, setText] = useState(initialText)
    const [language, setLanguage] = useState(initialLanguage)

    useEffect(() => {
        if (open) {
            setText(initialText)
            setLanguage(initialLanguage)
        }
    }, [open, initialText, initialLanguage])

    const languageValid = !askLanguage || LANGUAGE_RE.test(language.trim().toLowerCase())
    const canSave = !!text.trim() && languageValid && (askLanguage || text.trim() !== initialText.trim())

    return (
        <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {hint && <DialogContentText sx={{mb: 2}}>{hint}</DialogContentText>}
                {askLanguage && (
                    <TextField
                        label="Language code (ISO 639-1)"
                        size="small"
                        value={language}
                        error={!!language && !languageValid}
                        helperText="e.g. de, fr, es, pt, ru"
                        onChange={(e) => setLanguage(e.target.value)}
                        sx={{mb: 2}}
                        autoFocus
                    />
                )}
                <TextField
                    label="Text"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    multiline
                    minRows={4}
                    fullWidth
                    autoFocus={!askLanguage}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" disabled={loading}>Cancel</Button>
                <LoadingButton
                    variant="contained"
                    loading={loading}
                    disabled={!canSave}
                    onClick={() => onSave({text: text.trim(), language: language.trim().toLowerCase()})}
                >
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}
